<template>
  <MainFilter useSearch v-model="modelFilters" :filtersList="renderFilters" :defaultValues="defaultFilterValues"
  :title="title" :description="props.description"
  :mobileFilters="mobileFilters"  :quantity="quantity" :searchPlaceholder="searchPlaceholder" suggestsResource="priceRow"
  resourceType="services" data-current-type="uslugi" @updateMobile="onUpdateMobile" @updateFilters="handleUpdateFilters">
    <template #bottom-desktop="{ filtersCount, clearFilters, isPreview }">
      <div class="main-filter__bottom _desktop main-filter__bottom--service" v-if="!isPreview">
        <FormCheckbox v-model="modelFilters.isAlwaysOpen" name="isAlwaysOpen" label="Клиника работает круглосуточно" />
        <button v-show="filtersCount" type="button" class="main-filter__clear"
                @click="clearFilters">
          Сбросить все
        </button>
      </div>
    </template>
  </MainFilter>
</template>

<script lang="ts" setup>
import type {TClinicFilter} from "~/types/clinic";
import type {TRangeValue} from '~/components/Form/FilterDropdown.vue';
import type {filterItem} from "~/components/MainFilter.vue";

const props = defineProps({
  filters: {
    type: Object as () => TClinicFilter,
  },
  title: {
    type: String,
    default: ''
  },
  quantity: {
    type: String,
    default: ''
  },
  description: {
    type: String,
    default: ''
  },
});

const emit = defineEmits(['updateOnMobile', 'updateFilters']);

const modelFilters = defineModel<Record<string, string | TRangeValue | boolean | null>>({required: true});
const defaultFilterValues = computed<TClinicFilter>(() => ({
  city: (modelFilters.value.city as string) || '',
  animal: 'zhivotnyh',
  service: '',
  priceRow: '',
  search: '',
  isAlwaysOpen: false,
}));

const mobileFilters: string[] = [];

const isMobile = ref<boolean>(false);

const renderFilters = computed(() => {
  let result: Record<string, filterItem> = {};

  if(!props.filters) return {};

  // Вид животного живёт в ServiceAnimalFilter отдельной строкой опций: на хабах его опции —
  // ссылки на видовые лендинги, а выпадающий список ссылку отрендерить не может (ТЗ §5, SC-7).

  const serviceItems = props.filters.service?.filter(item => !item.disabled);
  if (serviceItems && serviceItems.length > 0) {
    // Ключ `priceRow`, а не `service`: в `service` лежит слаг самой страницы каталога, и
    // список рисовал бы его как выбранную строку прайса при совпадении слагов.
    //
    // Выпадающего списка у каталога нет — он дублировал сетку под собой (ТЗ §6.4), а выбор
    // каноники ушёл в ряд чипов. Запись остаётся только источником саджеста поиска (§6.2),
    // поэтому скрыта из обоих рядов и не считается фильтром.
    result.priceRow = {
      label: "Услуги",
      hideFromDesktopRow: true,
      excludeFromCount: true,
      items: props.filters.service.map(group => ({
        id: group.id,
        label: group.label,
        slug: group.slug,
        items: group.services.map(service => ({
          id: service.id,
          slug: service.slug,
          label: service.label,
          disabled: service.disabled
        }))
      }))
    };
  }

  return result;
})

const searchPlaceholder = computed(() => {
  // if(isMobile.value) {
  //   return 'Поиск клиник по названию услуги';
  // }
  return 'Поиск клиник по названию услуги';
})

const onUpdateMobile = (newFilters: any) => {
  if(window.innerWidth > 768) return;
  emit('updateOnMobile', newFilters);
}

const handleUpdateFilters = (updatedFilters: Record<string, any>) => {
  emit('updateFilters', updatedFilters);
}

onMounted(() => {
  isMobile.value =  window.innerWidth <= 768;
})
</script>